import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Modal from 'components/Modal/Modal';
import { AppRoutes } from 'constants/AppRoutes';
import { BUTTON_VARIANT } from 'constants/interfaces';

import { setSurveyToken } from '../../store/slices/survey/slice';

import type { ReactElement } from 'react';
import type {
  ISurveyAnswerRegisterModal,
} from '../../pages/MaterialAssessmentPages/MaterialAssessmentSurveyAnswer/interfaces/ISurveyAnswerRegisterModal';

function RegistrationModal({
  open,
  onClose,
  surveyToken,
  surveyType,
}: ISurveyAnswerRegisterModal): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleRegister = () => {
    const loginUrl = AppRoutes.login;
    navigate(loginUrl);
    dispatch(setSurveyToken({
      token: surveyToken,
      surveyType,
    }));
  };

  const handleReject = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      title={t('registrationModal.title', 'Registration')}
      description={t(
        'registrationModal.description',
        'Would you like to register?',
      )}
      confirmTitle={t('registrationModal.register', 'Yes, Register')}
      closeTitle={t('common.cancel', 'Cancel')}
      confirmVariant={BUTTON_VARIANT.primary}
      onConfirm={handleRegister}
      onReject={handleReject}
      onClose={onClose}
    />
  );
}

export default RegistrationModal;
